import { useEffect, useState } from "react";
import { ContactFormatEnum } from "../dth/ContactFormatEnum";
import { CONTACT_FORMAT_CAN_CHANGE_DISPLAY_NAME_IN_CHAT } from "../dth/constants";
import SettingsStore from "../settings/SettingsStore";
import { getContactFormatOrDefault } from "../dth/utils";

/**
 * Hook per gestire il formato dei contatti e il watcher su SettingsStore.
 * Restituisce il formato attuale e una funzione che processa il nome.
 */
export function useContactFormatWatcher() {
    const [contactFormat, setContactFormat] = useState<ContactFormatEnum | null>(null);

    useEffect(() => {
        let watcherId: string | undefined;
        // Se il formato dei contatti può cambiare dinamicamente, 
        // imposta il watcher sulla configurazione e aggiorna lo stato locale
        if (CONTACT_FORMAT_CAN_CHANGE_DISPLAY_NAME_IN_CHAT) {
            // Imposta il formato del nome dei contatti in base alla configurazione attuale
            setContactFormat(getContactFormatOrDefault());

            watcherId = SettingsStore.watchSetting(
                "contact_format",
                null,
                (_name, _room, _level, _valAtLevel, newVal) => {
                    // Aggiorna il formato del nome dei contatti quando la configurazione cambia
                    if (contactFormat !== newVal) setContactFormat(newVal);
                }
            );
        }
        return () => {
            if (watcherId !== undefined) {
                SettingsStore.unwatchSetting(watcherId);
            }
        };
    }, []);

    return {
        contactFormat
    };
}
